var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.alert.message)?_c('div',{staticClass:"is-radiusless notification top-bar-alert",class:_vm.alert.type},[_vm._v(" "+_vm._s(_vm.alert.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }